<template>
    <div class="filter-panel">
        <div v-show="!opened" class="btn-toggle" @click="toggle"></div>


        <div v-show="opened" v-bind:id="id" class="filter-box">
            <div class="btn-toggle opened" @click="toggle"></div>
            <div class="wrapper">
                <div class="text-center title">{{ t('Filtering')}}</div>
                <div class="options">
                    <slot></slot>
                </div>

                <br />
            </div>
        </div>
    </div>
</template>

<script>
    export default
    {
        props: {
            id: {
                default: 'filter-panel'
            }
        },
        computed: {

        },
        data() {
            return {
                opened: false,
            };
        },
        methods:
        {
            toggle() {
                this.opened = !this.opened
            }
        }
    }
</script>

<style lang="sass">
    .filter-panel
    {
        .btn-toggle {
            width:52px;
            height:52px;
            background-image: url('../assets/img/settings-dark.png');
            z-index:9999;

            &.active, &:hover {
                background-position: -52px 0;
                cursor: pointer;
            }

            &:not(.opened) {
                position: fixed;
                float: right;
                right: 0;
            }

            &.opened {
                position: absolute;
                margin-left: -27px;
                margin-top: 10px;
            }
        }

        .filter-box
        {
            top:150px;
            z-index: 999;
            position:fixed;
            background-color:white;
            width:350px;
            height:auto;
            min-height:200px;
            right:0;
            /*border:1px solid black;*/
            border-radius: 10px 0px 0px 10px;
            box-shadow: -10px 10px 20px rgba(0, 0, 0, .1);

            .title {
                margin-top:15px;
                font-size:20px;
            }

            .options {
                margin-top:30px;

                .option {
                    margin-bottom: 8px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// FilterPanel.vue?7959d360